var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolicyInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "#F8F6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14.25 20.3C14.25 18.6198 14.25 17.7798 14.577 17.138C14.8646 16.5735 15.3235 16.1146 15.888 15.827C16.5298 15.5 17.3698 15.5 19.05 15.5H29.45C31.1302 15.5 31.9702 15.5 32.612 15.827C33.1765 16.1146 33.6354 16.5735 33.923 17.138C34.25 17.7798 34.25 18.6198 34.25 20.3V26.7C34.25 28.3802 34.25 29.2202 33.923 29.862C33.6354 30.4265 33.1765 30.8854 32.612 31.173C31.9702 31.5 31.1302 31.5 29.45 31.5H19.05C17.3698 31.5 16.5298 31.5 15.888 31.173C15.3235 30.8854 14.8646 30.4265 14.577 29.862C14.25 29.2202 14.25 28.3802 14.25 26.7V20.3Z",
    fill: "#6B47F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 25.5C19.3284 25.5 20 24.8284 20 24C20 23.1716 19.3284 22.5 18.5 22.5C17.6716 22.5 17 23.1716 17 24C17 24.8284 17.6716 25.5 18.5 25.5Z",
    fill: "#6B47F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 25.5C19.7426 25.5 20.75 26.5074 20.75 27.75V28.5H16.25V27.75C16.25 26.5074 17.2574 25.5 18.5 25.5Z",
    fill: "#6B47F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 26C22.25 25.7239 22.4739 25.5 22.75 25.5H30.75C31.0261 25.5 31.25 25.7239 31.25 26C31.25 26.2761 31.0261 26.5 30.75 26.5H22.75C22.4739 26.5 22.25 26.2761 22.25 26Z",
    fill: "#6B47F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 28C22.25 27.7239 22.4739 27.5 22.75 27.5H26.75C27.0261 27.5 27.25 27.7239 27.25 28C27.25 28.2761 27.0261 28.5 26.75 28.5H22.75C22.4739 28.5 22.25 28.2761 22.25 28Z",
    fill: "#6B47F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicyInfo);
export default __webpack_public_path__ + "static/media/policyInfo.a8bc73d3bb0632ae20e72384d8700b10.svg";
export { ForwardRef as ReactComponent };